import { Component, Input, OnInit } from '@angular/core';

import { AlertService, DeliveryStoreService, IAlertType } from "../../../_shared/services";
import { Delivery, StatusButtons } from '../../../_shared/interfaces';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule, ClrLoadingModule } from '@clr/angular';
import { ActivatedRoute, RouterLink } from "@angular/router";
import { DatePipe, NgIf } from "@angular/common";
import { checkCircleIcon, ClarityIcons, infoCircleIcon, twoWayArrowsIcon } from "@cds/core/icon";
import {
  JobDetailsDeliveriesComponent
} from "../../jobs/job-details/job-details-deliveries/job-details-deliveries.component";

@Component({
  selector: 'app-delivery-overview',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    ClrIconModule,
    NgIf,
    JobDetailsDeliveriesComponent,
    ClrLoadingModule
  ],
  templateUrl: './delivery-overview.component.html',
  styleUrl: './delivery-overview.component.sass'
})
export class DeliveryOverviewComponent implements OnInit {
  status: string = 'all';
  deliveries: Delivery[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusLabel = 'alert-info';
  statusText = '';
  statusIcon = 'info-circle'

  @Input() projectId: string = '';
  @Input() jobId: number = 0;

  constructor(
    private delss: DeliveryStoreService,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon, infoCircleIcon, checkCircleIcon)
  }

  ngOnInit(): void {
    const params = this.route.snapshot.paramMap;
    this.status = params.get('status') || 'all';
    this.loading = true;
    this.loadList();
  }

  statusButtons: StatusButtons[] = [
    { state: 'open',   display: 'Offen',   label: 'alert-info',    icon: 'info-circle'},
    { state: 'closed', display: 'Gebucht', label: 'alert-success', icon: 'check-circle'},
    { state: 'noinvoice', display: 'Ohne Rechnung', label: 'alert-warning', icon: 'exclamation-triangle'}
  ];

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(invoicestatus: string) {
    // findButtonStatus liefert -1, wenn der Status unbekannt ist -- ein
    // direkter Zugriff darauf wirft und reisst die ganze Tabelle mit. Genau so
    // blieb der Lieferschein-Reiter leer bzw. im Ladekreis haengen, als das
    // Vokabular um einen Status erweitert wurde, den diese Liste nicht kannte.
    const treffer = this.statusButtons[this.findButtonStatus(invoicestatus, this.statusButtons)];
    return treffer?.label ?? 'label-light-blue';
  }

  loadList() {
    this.delss.getDelivery('0', 0, 0, this.status).subscribe({
      next: data => {
        this.deliveries = data?.object ?? [];
        if (this.deliveries.length === 0) {
          this.alertDispatcher.show({
            message: 'Keine Lieferscheine gefunden.',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      }
    });
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus) + " alert-sm";
  }
}
